import { api } from '@/config/api';

export interface Subscription {
  _id: string; companyUid: string;
  planId: { _id: string; displayName: string } | string;
  action: string; effectiveFrom: string; note?: string; createdAt: string;
}

export interface SubscriptionRow {
  _id: string; companyUid: string; action: string; createdAt: string;
  /** Operator note captured when the change was made (change plan / extend expiry). */
  note?: string;
  company: { name: string; status: string };
  plan: { displayName: string };
}

export const subscriptionsService = {
  byCompany: async (uid: string): Promise<Subscription[]> => (await api.get(`/super_admin/subscriptions/by-company/${uid}`)).data,
  changePlan: async (uid: string, planId: string, note?: string) => (await api.patch(`/super_admin/subscriptions/${uid}/change-plan`, { planId, note })).data,
  extendExpiry: async (uid: string, newExpiresAt: string, note?: string) => (await api.patch(`/super_admin/subscriptions/${uid}/extend-expiry`, { newExpiresAt, note })).data,
  listAll: async (page = 1, limit = 50): Promise<{ items: SubscriptionRow[]; total: number; page: number; limit: number }> =>
    (await api.get('/super_admin/subscriptions', { params: { page, limit } })).data,
};
